<template>
  <div id="days-selection">
    <div id="title">
      {{ $ts('toursSettings.common.daysAvailable') }}
    </div>

    <div
      id="days-row"
      class="d-flex justify-content-between"
    >
      <div
        v-for="(day, idx) in days"
        :id="`${idx}-day`"
        :key="idx"
        :class="`day-box d-flex justify-content-center align-items-center ${day.selected ? 'selected' : ''}`"
        @click="handleDayClicked(day)"
      >
        <span>
          {{ $ts(`toursSettings.common.${day.value}Initial`) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsDaysSelection',
  props: {
    value: {
      type: Array as PropType<ISelectOption[]>,
      default: () => [],
    },
    /**
     * Vue 3 v-model binding. Kept alongside the legacy `value`/`input` pair so
     * both `v-model` (modelValue/update:modelValue) and explicit `:value`+`@input`
     * consumers work. `undefined` means the parent did not bind v-model, so we
     * fall back to `value` (see the `boundValue` computed).
     */
    modelValue: {
      type: Array as PropType<ISelectOption[]>,
      default: undefined,
    },
  },

  emits: ['input', 'update:modelValue'],
  data() {
    return {
      days: [
        {
          value: 'sunday',
          text: 'S',
          selected: false,
        },
        {
          value: 'monday',
          text: 'M',
          selected: false,
        }, {
          value: 'tuesday',
          text: 'T',
          selected: false,
        }, {
          value: 'wednesday',
          text: 'W',
          selected: false,
        }, {
          value: 'thursday',
          text: 'T',
          selected: false,
        }, {
          value: 'friday',
          text: 'F',
          selected: false,
        },
        {
          value: 'saturday',
          text: 'S',
          selected: false,
        } ] as ISelectOption[],
    };
  },
  computed: {
    /**
     * The externally-bound value, preferring the Vue 3 `modelValue` (v-model)
     * when present and falling back to the legacy `value` prop otherwise.
     */
    boundValue(): ISelectOption[] {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
    selectedDays(): ISelectOption[] {
      return this.days.filter((d: ISelectOption) => d.selected);
    },
  },
  watch: {
    boundValue() {
      this.boundValue.forEach((day) => {
        const lookupDay = this.days.find((searchDay) => searchDay.value === day.value);
        lookupDay!!.selected = day.selected;
      });
    },
  },
  methods: {
    handleDayClicked(day: ISelectOption) {
      day.selected = !day.selected;
      this.$emit('update:modelValue', this.selectedDays);
      this.$emit('input', this.selectedDays);
    },
  },
});

</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
#days-selection {
  width: 274px;
  height: 64px;
}

#title {
  color: $secondary-color-dark;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 11px;
}

.day-box {
  width: 34px;
  height: 34px;
  background-color: #C9CCDF;
  color: $secondary-color-dark;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
}

.selected {
  color: #fff;
  background-color: $secondary-color;
}

</style>
